import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        api: 'https://flota.autorent.hr/api/',
        token: null,
        rememberLogin: false,

        cars: null, //list of loaded cars
        categories: null, //list of loaded categories
        events: null, //list of loaded events
        prettyCategories: [], //formated category list 

        selectedCar: null, //selected car on car list
        selectedEvent: null, //selected event on event list
        selectedCategory: null, //selected category on categories list

        hideLoadingIndicator: true, //flag for loading indicator true = hidden, false = show
        hideCloseIcon: true, //flag for close icon true= hidden, false= show
        hideSettingIcon: true, //flag for setting icon true= hidden, false= show
        hideFloatWidgetRight: true, //flag for float widget right true= hidden, false= show
        hideReturnIcon: true, //flag for return icon true= hidden, false= show
        viewTitle: 'mFleet',

        currentView: null,
        previousView: null,

        fuelList: ['Dizel', 'Benzin'],
        mjenjacList: ['Ručni', 'Automatski'],
        eventNameList: ['Najam', 'Rezervacija'], // najam, rezervacija - obavezni poredak
        eventStatusList: ['Aktivno', 'Završeno'], // aktivno, završeno - obavezni poredak
    },
    mutations,
    actions,
    getters
})